import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { $CampaignBanner } from 'shared/atoms/common/campaign-banner';

export const PreloadCampaignBanner: FC = () => {
  const campaign = useAtomValue($CampaignBanner)[0];
  if (!campaign) {
    return null;
  }

  return <link rel="preload" as="image" href={campaign.bannerUrl} />;
};
